import {
    CardType,
    mapPaymentType,
    PaymentOptionsApiResponse,
    PaymentOptions,
} from 'components/customer/Confirmation/Payment/entity/PaymentSession';
import {camelizeKeys} from 'humps';

export interface PaymentSummaryApiResponse {
    success: boolean;
    intent_id: string;
    final_amount: number;
    base_amount: number;
    surcharge_amount: number;
    surcharge_applied: boolean;
    platform_fee: number;
    tax_amount: number;
    platform_fee_tax_amount: number;
    surcharge_tax_amount: number;
    total_tax_amount: number;
    payment_method_type: CardType;
    selected_payment_method_type: CardType;
    default_payment_method_type: CardType;
    currency: 'AUD' | 'NZL';
    client_secret: string;
    payment_options: PaymentOptionsApiResponse;
}

export interface PaymentSummary {
    success: boolean;
    intentId: string;
    finalAmount: number;
    baseAmount: number;
    surchargeAmount: number;
    surchargeApplied: boolean;
    platformFee: number;
    taxAmount: number;
    platformFeeTaxAmount: number;
    surchargeTaxAmount: number;
    totalTaxAmount: number;
    paymentMethodType: CardType;
    selectedPaymentMethodType: CardType;
    defaultPaymentMethodType: CardType;
    currency: 'AUD' | 'NZL';
    clientSecret: string;
    paymentOptions: PaymentOptions;
}

export const mapPaymentSummary = (data: PaymentSummaryApiResponse) => {
    return camelizeKeys(mapPaymentType(data)) as PaymentSummary;
};
